<template>
    <div class="uep-comment-item">
        <!--- comment container - enabled -->
        <div v-show="comment.status">
            <!-- Show comment container -->
            <div class="container d-flex pl-1 pr-1" v-show="state === 'default'">
                <div class="col-3 col-md-2 img-user"></div>
                <div class="col-9 col-md-10 d-flex pl-0 pr-0">
                    <!-- Comment content container -->
                    <div class="col-11 col-md-11 pl-0 pr-0 pt-2">
                        <span class="author-name" :class="{'my-comment': editable}">{{ comment.author.name }} - </span>
                        <span class="comment-body">{{ comment.body }}</span>
                        <div class="d-flex">
                            <div class="col-6 col-md-6 created-at-text">{{ comment.created_at | formatDate }}</div>
                            <div class="col-6 col-md-6 text-right pr-0 hidden comment-response " @click="toggleResponse">{{$t('worksapce.buttons.reply-comment')}}</div>
                        </div>
                    </div><!-- /Comment content container -->
                    <!-- Show more options container -->
                    <div class="col-1 col-md-1 pl-0 pr-0 more-options">
                        <b-dropdown :id="'ddown-comment-options-' + comment.id" text="" class="text-sm hidden btn-comment-more">
                            <b-dropdown-item @click="hideComment">
                                <div class="icon hide"></div>{{$t('worksapce.buttons.hide-comment')}}
                            </b-dropdown-item>
                            <b-dropdown-item>
                                <div class="icon info"></div>{{$t('worksapce.buttons.info-comment')}}
                            </b-dropdown-item>
                            <b-dropdown-item v-show="editable" @click="toggleEdit">
                                <div class="icon edit"></div>{{$t('worksapce.buttons.edit-comment')}}
                            </b-dropdown-item>
                        </b-dropdown>
                    </div><!-- /Show more options container -->
                </div>
            </div><!-- /Show comment container -->
            <!-- Show replys container -->
            <div class="offset-md-2 col-md-9 pl-1 pr-0 comment-responses">
                <div v-for="(response, index) in comment.responses"
                     :class="[index > nbComment ? 'hidden' : '']"
                     class="comment-response mt-1">
                    <div class="col-md-12 pl-2 pr-0 pt-2 pb-2">
                        <span class="author-name" :class="{'my-comment': editable}">{{ response.author.name }} - </span>
                        <span class="comment-body">{{ response.body }}</span>
                        <div class="created-at-text">{{ response.created_at | formatDate }}</div>
                    </div>
                </div>
                <div class="comment-response show-more-container mt-1">
                    <div @click="showMoreReplies" v-show="canShowMoreReply" class="text-center">
                        <div class="show-more-button">{{$t('worksapce.buttons.show-more')}}</div>
                    </div>
                    <div @click="showLessReplies" v-show="canShowLessReply" class="text-center">
                        <div class="show-less-button">{{$t('worksapce.buttons.show-less')}}</div>
                    </div>
                </div>
            </div><!-- /Show replys container -->
            <!-- Edit comment container -->
            <div class="container pl-1 pr-1 mt-1 edit-container" v-show="state === 'editing'">
                <div class="offset-md-2 col-md-9 pl-0 pr-0">
                    <div class="edit-field-container">
                        <textarea v-model="data.body"
                                  placeholder="Update comment"
                                  class="bg-grey-lighter rounded leading-normal resize-none w-full h-24 py-2 px-3">
                        </textarea>
                    </div>
                    <div class="text-right" v-show="!cancelMode">
                        <button class="btn-edit-comment update" @click="saveEdit" :title="$t('worksapce.titles.edit-button')"></button>
                        <button class="btn-edit-comment cancel" @click="resetEdit" :title="$t('worksapce.titles.cancel-button')"></button>
                        <button class="btn-edit-comment delete" @click="enableTrashComment" :title="$t('worksapce.titles.delete-button')"></button>
                    </div>

                    <div class="text-right" v-show="cancelMode">
                        <button class="btn-edit-comment confirm" @click="trashComment">{{$t('worksapce.buttons.confirm-delete')}}</button>
                        <button class="btn-edit-comment cancel-delete" @click="disableTrashComment">{{$t('worksapce.buttons.cancel-delete')}}</button>
                    </div>
                </div>
            </div><!-- /Edit comment container -->
            <!-- Reply to comment container -->
            <div class="container pl-1 pr-1 mt-1 edit-container" v-show="state === 'response'">
                <div class="offset-md-2 col-md-9 pl-0 pr-0">
                    <div class="edit-field-container">
                        <textarea v-model="data.response" ref="replyField" :placeholder="$t('worksapce.buttons.reply-comment')"
                                  class="bg-grey-lighter rounded leading-normal resize-none w-full h-24 py-2 px-3">
                        </textarea>
                    </div>
                    <div class="text-right">
                        <button class="btn-edit-comment add" @click="reply" :title="$t('worksapce.buttons.add-reply')"></button>
                        <button class="btn-edit-comment cancel" @click="toggleResponse" :title="$t('worksapce.buttons.cancel-delete')"></button>
                    </div>
                </div>
            </div><!-- /Reply to comment container -->
        </div><!--- /comment container - enabled -->
        <!--- comment container - disabled -->
        <div class="container show-comment-constainer text-center" v-show="!comment.status" @click="showComment" :title="$t('worksapce.titles.show-comment')">
            <div class="show-comment-button"></div>
        </div><!--- /comment container - disabled -->
    </div>
</template>

<script>
    import {HTTP} from '../../core/http/http-common';
    import Routing from '../../core/router/router';
    import { mapGetters, mapActions } from 'vuex';
    import helper from '../../mixins/helper';
    import en from '../../i18n/en_US';
    import fr from '../../i18n/fr_FR';

    export default {
        name: "uep-comment-item",
        i18n: {
            messages: {
                en: en,
                fr: fr
            }
        },
        mixins: [helper],
        props: {
            comment: {
                required: true,
                type: Object,
            }
        },
        data: function() {
            return {
                state: 'default',
                data: {
                    body: this.comment.body,
                    response: ''
                },
                cancelMode: false,
                responsesLength: 0,
                nbComment: 2
            }
        },
        mounted () {
            /* initialize the number of replies */
            if (this.comment.responses !== undefined) {
                this.responsesLength = this.comment.responses.length;
            } else {
                this.responsesLength = 0;
            }
        },
        computed: {
            /**
             * Getters from Vuex Store
             */
            ...mapGetters({
                videoId: 'getVideoId',
                mediaId: 'getMediaId',
                clientId: 'getClient',
                currentUser: 'getCurrentUser',
            }),
            /**
             * Check the comment is editable or not
             *
             * @function    editable
             */
            editable () {
                return this.currentUser.id == this.comment.author.id;
            },
            /**
             * Check if can show the more comment button
             *
             * @function    canShowMoreReply
             */
            canShowMoreReply () {
                if (this.responsesLength <= (this.nbComment + 1)) {
                    return false;
                }
                return this.responsesLength > 3;
            },
            /**
             * Check if can show the less comment button
             *
             * @function    canShowLessReply
             */
            canShowLessReply () {
                if (this.responsesLength <= (this.nbComment + 1) && this.responsesLength > 3) {
                    return true;
                }
                return false;
            }
        },
        methods: {
            /**
             * Actions from Vuex Store
             */
            ...mapActions([
                'editComment',
                'deleteComment',
                'addResponse',
                'disableComment',
                'enableComment',
            ]),
            /**
             * Show more comment's replies
             *
             * @function    showMoreReplies
             */
            showMoreReplies () {
                this.nbComment += 3;
            },
            /**
             * Show less comment's replies
             *
             * @function    showLessReplies
             */
            showLessReplies () {
                this.nbComment = 2;
            },
            /**
             * Reset the edit fields & mode
             *
             * @function    resetEdit
             */
            resetEdit() {
                this.state = 'default';
                this.data.body = this.comment.body;
            },
            /**
             * Save the edited comment
             *
             * @function    saveEdit
             */
            saveEdit() {
                this.state = 'default';
                this.editCommentApi({id: this.comment.id, comment: this.data.body});
                this.editComment({id: this.comment.id, body:this.data.body});
            },
            /**
             * Show delete confirmation / cancel
             *
             * @function    enableTrashComment
             */
            enableTrashComment () {
                this.cancelMode = true;
            },
            /**
             * Hide delete confirmation / cancel
             *
             * @function    disableTrashComment
             */
            disableTrashComment () {
                this.cancelMode = false;
            },
            /**
             * Delete the selected comment
             *
             * @function    trashComment
             */
            trashComment() {
                this.deleteCommentApi(this.comment.id);
                this.deleteComment(this.comment.id);
            },
            /**
             * Hide the selected comment
             *
             * @function    hideComment
             */
            hideComment () {
                this.disableComment(this.comment.id);
                this.disableCommentApi(this.comment.id);
            },
            /**
             * Show the selected comment
             *
             * @function    showComment
             */
            showComment () {
                this.enableComment(this.comment.id);
                this.enableCommentApi(this.comment.id);
            },
            /**
             * Show/Hide the edit mode
             *
             * @function    toggleEdit
             */
            toggleEdit() {
                this.state = this.state === 'default' ? 'editing' : 'default';
            },
            /**
             * Show/hide response field
             *
             * @function    toggleResponse
             */
            toggleResponse() {
                this.state = this.state === 'default' ? 'response' : 'default';
                if (this.state === 'response') {
                    setTimeout(() => {this.$refs.replyField.focus()});
                }
            },
            /**
             * Hide response field
             *
             * @function    stopReply
             */
            stopReply() {
                this.state = 'default';
                this.data.response = '';
            },
            /**
             * Add response to the selected comment
             *
             * @function    reply
             */
            reply () {
                let newResponse = {
                    body: this.data.response,
                    edited: false,
                    status: true,
                    created_at: new Date(),
                    author: {
                        id: this.currentUser.id,
                        name: this.currentUser.name,
                    }
                };
                this.responsesLength++;
                this.replyCommentApi(this.comment.id, this.data.response);
                this.addResponse({comment: this.comment, response: newResponse});
                this.stopReply();
            },
            /**
             * Post the comment (store in the DB)
             *
             * @function    editCommentApi
             *
             * @param       comment
             */
            editCommentApi (comment) {
                let params = {empMediaCommentsForm:{comment: comment.comment, parent: '', media: this.mediaId}};
                HTTP.post(Routing.generate("api_media_post_edit_comments", {id: comment.id, client: this.clientId}), params, {emulateJSON: true})
                    .then(function (response) {
                        if (response.data.code === 200) {

                        }
                    }, function (response) {
                        console.log('api error' + response);
                        eventHub.$emit('error',{code: response.code, cause: response.message})
                    });

            },
            /**
             * Post the comment (store in the DB)
             *
             * @function    deleteCommentApi
             *
             * @param       idComment
             */
            deleteCommentApi (idComment) {
                let self = this;
                HTTP.delete(Routing.generate("api_media_delete_comments", {id: idComment, client: this.clientId}), {emulateJSON: true})
                    .then(function (response) {
                        if (response.data.code === 200) {
                            self.sweetAlert('Deleted');
                        }
                    }, function (response) {
                        console.log('api error' + response);
                      eventHub.$emit('error',{code: response.code, cause: response.message})
                    });

            },
            /**
             * Post to disable the comment
             *
             * @function    disableCommentApi
             *
             * @param       idComment
             */
            disableCommentApi (idComment) {
                HTTP.post(Routing.generate("api_media_post_disable_comments", {id: idComment, client: this.clientId}), {emulateJSON: true})
                    .then(function (response) {
                        if (response.data.code === 200) {

                        }
                    }, function (response) {
                        console.log('api error' + response);
                      eventHub.$emit('error',{code: response.code, cause: response.message})
                    });

            },
            /**
             * Post to enable the comment
             *
             * @function    enableCommentApi
             *
             * @param       idComment
             */
            enableCommentApi (idComment) {
                HTTP.post(Routing.generate("api_media_post_enable_comments", {id: idComment, client: this.clientId}), {emulateJSON: true})
                    .then(function (response) {
                        if (response.data.code === 200) {

                        }
                    }, function (response) {
                        console.log('api error' + response);
                      eventHub.$emit('error',{code: response.code, cause: response.message})
                    });

            },
            /**
             * Post the comment (store in the DB)
             *
             * @function    replyCommentApi
             *
             * @param       parent
             * @param       comment
             */
            replyCommentApi (parent, comment) {
                let params = {
                    empMediaCommentsForm:{
                        comment: comment,
                        parent: parent,
                        user: this.currentUser.id + ';' + this.currentUser.name,
                        email: this.currentUser.email,
                        media: this.mediaId
                    }
                };
                HTTP.post(Routing.generate("api_media_post_add_comments", {client: this.clientId}), params, {emulateJSON: true})
                    .then(function (response) {
                        if (response.data.code === 200) {

                        }
                    }, function (response) {
                        console.log('api error' + response);
                      eventHub.$emit('error',{code: response.code, cause: response.message})
                    });

            }
        }
    }
</script>

<style lang="scss">
    @import "../../assets/scss/workspace/_commentItem.scss";
</style>



// WEBPACK FOOTER //
// src/components/workspaceComponents/UepCommentItem.vue